export default "<ngx-spinner bdColor=\"rgba(51, 51, 51, 0.8)\" size=\"medium\" color=\"#ff9e18\" type=\"ball-fussion\"></ngx-spinner>";